<template>
    <div class="color-picker-wrapper">
        <b-form-input
            ref="colorTextInput"
            v-model="localValue"
            type="text"
            class="color-value-input"
            @input="updateColor"
        />
        <div class="color-square" :class="{ 'none': !localValue, 'invalid': !isValidHexColor }" :style="{ backgroundColor: isValidHexColor ? localValue: '' }" @click="triggerColorPicker"></div>
        <b-form-input
            ref="colorInput"
            v-model="localValue"
            type="color"
            class="color-input"
            @input="throttleUpdateColor"
        />
    </div>
</template>

<script>
    import throttle from 'lodash/throttle';
    import { hexColor } from '@/utils/validators';

    export default {
        name: 'FormColorPicker',
        props: {
            value: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                localValue: this.value,
            };
        },
        computed: {
            isValidHexColor() {
                return this.localValue ? hexColor(this.localValue) : true;
            },
        },
        watch: {
            value(newValue) {
                this.localValue = newValue;
            },
        },
        methods: {
            updateColor(newColor) {
                this.$emit('input', newColor);
            },
            throttleUpdateColor: throttle(function throttleUpdateColor(newColor) {
                this.updateColor(newColor);
            }, 100),
            triggerColorPicker() {
                this.$refs.colorInput.$el.click();
            },
        },
    };
</script>

<style lang="scss" scoped>
    $padding-x: $input-padding-y-sm;
    $padding-y: $input-padding-y-sm;
    $height: calc(#{$input-height} - #{2 * $padding-y});
    $width: $height;

    .color-picker-wrapper {
        display: flex;
        align-items: center;
        position: relative;
    }

    .color-square {
        position: absolute;
        left: $padding-x;
        top: $padding-y;
        width: $width;
        height: $height;
        cursor: pointer;
        border: $input-border-width solid $input-border-color;

        &.invalid {
            background: linear-gradient(45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 47%, #f00 47%, #f00 53%, rgba(0, 0, 0, 0) 53%, rgba(0, 0, 0, 0) 100%), linear-gradient(135deg, #fff 0%, #fff 47%, #f00 47%, #f00 53%, #fff 53%, #fff 100%);
        }

        &.none {
            background: conic-gradient(#ccc 25%, #fff 0 50%, #ccc 0 75%, #fff 0) 50% / calc(#{$height} / 2) calc(#{$height} / 2);
        }
    }

    .color-value-input {
        padding-left: calc(#{$input-height} + #{$padding-x});
    }

    .color-input {
        display: none !important;
    }
</style>
